import React from "react";
import { Link, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Error from "./Pages/Home/Error";
import Auth from "./Pages/Auth/Auth";
import ChatBot from "./Pages/ChatBot/ChatBot";
import Login from "./Pages/OTP/Login";
import Register from "./Pages/OTP/Register";
import Otp from "./Pages/OTP/Otp";
import Payment from "./Pages/Payment/Payment";
import Questions from "./Pages/Questions/Questions";
import AskQuestion from "./Pages/AskQuestion/AskQuestion";
import DisplayQuestion from "./Pages/Questions/DisplayQuestion";
import Tags from "./Pages/Tags/Tags";
import Users from "./Pages/Users/Users";
import UserProfile from "./Pages/UserProfile/UserProfile";

const AllRoutes = ({ slideIn, handleSlideIn }) => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home slideIn={slideIn} handleSlideIn={handleSlideIn} />} />
        <Route path="*" element={<Error />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/chatbot" element={<ChatBot />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/user/otp" element={<Otp />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/askquestion" element={<AskQuestion />} />
        <Route path="/questions" element={<Questions slideIn={slideIn} handleSlideIn={handleSlideIn} />} />
        <Route path="/questions/:id" element={<DisplayQuestion slideIn={slideIn} handleSlideIn={handleSlideIn} />} />
        <Route path="/tags" element={<Tags slideIn={slideIn} handleSlideIn={handleSlideIn} />} />
        <Route path="/users" element={<Users slideIn={slideIn} handleSlideIn={handleSlideIn} />} />
        <Route path="/users/:id" element={<UserProfile slideIn={slideIn} handleSlideIn={handleSlideIn} />} />
      </Routes>
      <Link to="/register">
        <button id="my-chat-btn">Chat</button>
      </Link>
    </>
  );
};

export default AllRoutes;